import { FrontendPlugin } from '@backstage/frontend-plugin-api';
import { convertLegacyPlugin, convertLegacyPageExtension } from '@backstage/core-compat-api';
import {
  convertLegacyEntityCardExtension,
  convertLegacyEntityContentExtension,
} from '@backstage/plugin-catalog-react/alpha';
import {
  techInsightsMaturityPlugin,
  EntityMaturitySummaryCard,
  EntityMaturityScorecardContent,
  MaturityPage,
} from '@backstage-community/plugin-tech-insights-maturity';
import { Entity } from '@backstage/catalog-model';

const isServiceComponent = (entity: Entity): boolean =>
  entity.kind === 'Component' &&
  (entity as any).spec?.type === 'service';

export const techInsightsMaturityCompatPlugin: FrontendPlugin = convertLegacyPlugin(
  techInsightsMaturityPlugin,
  {
    extensions: [
      convertLegacyEntityCardExtension(EntityMaturitySummaryCard, {
        name: 'tech-insights-maturity-summary',
        filter: isServiceComponent,
        type: 'info'
      }),
      convertLegacyEntityContentExtension(EntityMaturityScorecardContent, {
        name: 'tech-insights-maturity-scorecard',
        path: '/tech-insights-maturity',
        title: 'Maturity',
        filter: isServiceComponent,
      }),
      convertLegacyPageExtension(MaturityPage, {
        name: 'tech-insights-maturity',
        path: '/tech-insights-maturity',
      }),
    ],
  },
);
